"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Content = void 0;
var tslib_1 = require("tslib");
var mithril_1 = tslib_1.__importDefault(require("mithril"));
var InterfaceTable_1 = require("./InterfaceTable");
var MethodsTable_1 = require("./MethodsTable");
var Examples = tslib_1.__importStar(require("../../../src/examples"));
var _1 = require("@/");
var highlightCode_1 = require("../utils/highlightCode");
_1.FocusManager.showFocusOnlyOnTab();
_1.ResponsiveManager.initialize();
function Content(attrs) {
    var pageData = attrs.docs.pages[attrs.page];
    var contentAttrs = {
        class: [
            'Docs-content',
            "Docs-content-".concat(pageData.reference)
        ].join(' '),
        key: attrs.page,
        id: attrs.page,
        oncreate: function () { return (0, highlightCode_1.highlightCode)(); }
    };
    return (0, mithril_1.default)('section', contentAttrs, [
        pageData.contents.map((function (contentBlock) {
            if (typeof (contentBlock) === 'string') {
                return mithril_1.default.trust(contentBlock);
            }
            var content = contentBlock;
            switch (content.tag) {
                case 'heading':
                    return (0, mithril_1.default)("h".concat(content.level), content.value);
                case 'methods':
                    return (0, MethodsTable_1.MethodsTable)({ api: content.value, data: attrs });
                case 'interface':
                    return (0, InterfaceTable_1.InterfaceTable)({ api: content.value, data: attrs });
                case 'example':
                    var example = Examples[content.value];
                    return example ? (0, mithril_1.default)(Examples[content.value]) : 'RENDER ERROR';
            }
        }))
    ]);
}
exports.Content = Content;
